import React from 'react';
import { problems } from '../data/content';
export function Problems() {
  return <section className="w-full border-t border-neutral-200 bg-white px-5 py-16 sm:px-8" data-id="element-230" data-mp="36w14pjlu4pfb">
      <div className="mx-auto w-full max-w-4xl" data-id="element-231" data-mp="3251526lbzt94">
        <h2 className="text-center text-2xl font-extrabold leading-tight tracking-tight text-neutral-900 sm:text-3xl md:text-[34px]" data-id="element-232" data-mp="323q1a6rvyli0">
          If you coach netball, you're probably living one of these problems:
        </h2>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-233" data-mp="2t29qvz12mjds">
          {problems.map(problem => <li key={problem} className="flex items-start gap-3 rounded-xl border border-neutral-200 bg-neutral-50 px-5 py-4" data-id="element-234" data-mp="2o7cld2302s5n">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-235" data-mp="2f5wlho9ta8fo">
                ❌
              </span>
              <span className="text-[15px] font-semibold text-neutral-900" data-id="element-236" data-mp="hea7d2xdego5">
                {problem}
              </span>
            </li>)}
        </ul>

        <p className="mt-12 text-center text-2xl font-extrabold leading-tight tracking-tight text-[#6d28d9] sm:text-3xl" data-id="element-237" data-mp="34qlkhhwhrloa">
          How many more sessions do you want to keep improvising?
        </p>
      </div>
    </section>;
}